// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Cosmic Insurance Styles
   ========================================== */

.insurance-header {
  text-align: center;
  margin-bottom: 3rem;
}

.insurance-types {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.insurance-type-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 2rem;
  border: 1px solid var(--border-bento);
  border-radius: var(--radius-bento-small);
  background: rgba(0, 0, 0, 0.3);
  min-width: 160px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.insurance-type-card:hover, .insurance-type-card.active {
  border-color: var(--color-neon-purple);
  background: rgba(176, 38, 255, 0.1);
  transform: translateY(-4px);
  box-shadow: var(--shadow-neon);
}

.type-icon {
  font-size: 2.5rem;
  margin-bottom: 0.75rem;
}

.insurance-type-card h3 {
  font-size: 1.1rem;
  color: #ffffff;
}

.plan-card {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.plan-card h3 {
  color: var(--color-neon-cyan);
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.plan-price {
  font-size: 3rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 1rem;
}

.plan-price span {
  font-size: 1.1rem;
  font-weight: 400;
  color: var(--text-muted);
}

.plan-coverage {
  color: var(--text-muted);
  font-style: italic;
  margin-bottom: 2rem;
}

.plan-features {
  list-style: none;
  flex-grow: 1;
  margin-bottom: 2rem;
}

.plan-features li {
  padding: 0.75rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
}

.select-plan-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--color-neon-cyan);
  color: var(--color-neon-cyan);
  padding: 1rem;
  border-radius: var(--radius-pill);
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.select-plan-btn:hover {
  background: var(--color-neon-cyan);
  color: #000000;
  box-shadow: 0 0 20px rgba(0, 240, 255, 0.4);
}

.application-form {
  max-width: 800px;
  margin: 0 auto;
}

.application-form h2 {
  text-align: center;
  color: #ffffff;
  margin-bottom: 1rem;
}

.selected-plan-info {
  text-align: center;
  color: var(--color-neon-purple);
  margin-bottom: 2.5rem;
  font-weight: 600;
}

.form-row {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 1rem;
  }
}

.form-group {
  flex: 1 1;
}

.form-group.full-width {
  flex: 0 0 100%;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #ffffff;
}

.submit-application-btn {
  background: var(--grad-cosmic);
  color: #ffffff;
  border: none;
  padding: 1.25rem;
  border-radius: var(--radius-pill);
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  margin-top: 1.5rem;
  transition: all 0.3s ease;
}

.submit-application-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-neon);
}

.insurance-footer {
  text-align: center;
  padding: 3rem;
  color: var(--text-muted);
}

.call-link {
  color: var(--color-neon-cyan);
  text-decoration: underline;
  margin-left: 0.5rem;
  font-weight: 600;
}

.call-link:hover {
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Insurance.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;EACrC,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,6BAA6B;EAC7B,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* ==========================================\n   Kubersetu Cosmic Insurance Styles\n   ========================================== */\n\n.insurance-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.insurance-types {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.insurance-type-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  border: 1px solid var(--border-bento);\n  border-radius: var(--radius-bento-small);\n  background: rgba(0, 0, 0, 0.3);\n  min-width: 160px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.insurance-type-card:hover, .insurance-type-card.active {\n  border-color: var(--color-neon-purple);\n  background: rgba(176, 38, 255, 0.1);\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-neon);\n}\n\n.type-icon {\n  font-size: 2.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.insurance-type-card h3 {\n  font-size: 1.1rem;\n  color: #ffffff;\n}\n\n.plan-card {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n}\n\n.plan-card h3 {\n  color: var(--color-neon-cyan);\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n\n.plan-price {\n  font-size: 3rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 1rem;\n}\n\n.plan-price span {\n  font-size: 1.1rem;\n  font-weight: 400;\n  color: var(--text-muted);\n}\n\n.plan-coverage {\n  color: var(--text-muted);\n  font-style: italic;\n  margin-bottom: 2rem;\n}\n\n.plan-features {\n  list-style: none;\n  flex-grow: 1;\n  margin-bottom: 2rem;\n}\n\n.plan-features li {\n  padding: 0.75rem 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  color: #e2e8f0;\n}\n\n.select-plan-btn {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--color-neon-cyan);\n  color: var(--color-neon-cyan);\n  padding: 1rem;\n  border-radius: var(--radius-pill);\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n}\n\n.select-plan-btn:hover {\n  background: var(--color-neon-cyan);\n  color: #000000;\n  box-shadow: 0 0 20px rgba(0, 240, 255, 0.4);\n}\n\n.application-form {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.application-form h2 {\n  text-align: center;\n  color: #ffffff;\n  margin-bottom: 1rem;\n}\n\n.selected-plan-info {\n  text-align: center;\n  color: var(--color-neon-purple);\n  margin-bottom: 2.5rem;\n  font-weight: 600;\n}\n\n.form-row {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n@media (max-width: 768px) {\n  .form-row {\n    flex-direction: column;\n    gap: 1rem;\n  }\n}\n\n.form-group {\n  flex: 1;\n}\n\n.form-group.full-width {\n  flex: 0 0 100%;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.submit-application-btn {\n  background: var(--grad-cosmic);\n  color: #ffffff;\n  border: none;\n  padding: 1.25rem;\n  border-radius: var(--radius-pill);\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  width: 100%;\n  margin-top: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.submit-application-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-neon);\n}\n\n.insurance-footer {\n  text-align: center;\n  padding: 3rem;\n  color: var(--text-muted);\n}\n\n.call-link {\n  color: var(--color-neon-cyan);\n  text-decoration: underline;\n  margin-left: 0.5rem;\n  font-weight: 600;\n}\n\n.call-link:hover {\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
